const mono = { fontFamily: "'Inter', ui-sans-serif, system-ui, sans-serif" };

export default function TaskComposerCard({
  title,
  subtitle,
  agents = [],
  selectedAgentId = "",
  onSelectAgentId,
  showAgentSelector = false,
  instruction,
  onInstructionChange,
  placeholder,
  onSubmit,
  onCancel,
  submitLabel = "Add Task",
  compact = false,
}) {
  return (
    <div
      style={{
        border: "1px solid rgba(255,255,255,0.08)",
        borderRadius: compact ? 12 : 6,
        padding: compact ? "12px 14px" : "8px 10px",
        background: compact ? "rgba(18,20,28,0.96)" : "transparent",
        boxShadow: compact ? "0 20px 50px rgba(0,0,0,0.35)" : "none",
      }}
    >
      {(title || subtitle) && (
        <div style={{ marginBottom: 8 }}>
          {title ? (
            <div
              style={{
                ...mono,
                fontSize: 10,
                color: "rgba(255,255,255,0.7)",
                textTransform: "uppercase",
                letterSpacing: "0.08em",
              }}
            >
              {title}
            </div>
          ) : null}
          {subtitle ? (
            <div
              style={{
                ...mono,
                fontSize: 10,
                color: "rgba(255,255,255,0.35)",
                marginTop: 2,
              }}
            >
              {subtitle}
            </div>
          ) : null}
        </div>
      )}

      {showAgentSelector ? (
        <div style={{ display: "flex", gap: 3, marginBottom: 6, flexWrap: "wrap" }}>
          {agents.map((agent) => (
            <button
              key={agent.id}
              onClick={() => onSelectAgentId?.(agent.id)}
              style={{
                ...mono,
                fontSize: 8,
                padding: "2px 8px",
                borderRadius: 10,
                cursor: "pointer",
                background:
                  selectedAgentId === agent.id ? `${agent.color}22` : "transparent",
                border: `1px solid ${
                  selectedAgentId === agent.id
                    ? `${agent.color}55`
                    : "rgba(255,255,255,0.08)"
                }`,
                color:
                  selectedAgentId === agent.id
                    ? agent.color
                    : "rgba(255,255,255,0.3)",
              }}
            >
              {agent.name}
            </button>
          ))}
        </div>
      ) : null}

      <textarea
        value={instruction}
        onChange={(event) => onInstructionChange(event.target.value)}
        placeholder={placeholder}
        rows={compact ? 3 : 2}
        style={{
          width: "100%",
          boxSizing: "border-box",
          ...mono,
          fontSize: compact ? 12 : 11,
          color: "white",
          background: "rgba(255,255,255,0.04)",
          border: "1px solid rgba(255,255,255,0.1)",
          borderRadius: 8,
          padding: compact ? "10px 12px" : "6px 8px",
          resize: "none",
          outline: "none",
          marginBottom: 8,
        }}
      />

      <div style={{ display: "flex", gap: 6 }}>
        <button
          onClick={onSubmit}
          style={{
            flex: 1,
            ...mono,
            fontSize: compact ? 11 : 9,
            padding: compact ? "9px 0" : "4px 0",
            background: "rgba(74,222,128,0.1)",
            border: "1px solid rgba(74,222,128,0.3)",
            color: "#4ade80",
            borderRadius: 8,
            cursor: "pointer",
          }}
        >
          {submitLabel}
        </button>
        <button
          onClick={onCancel}
          style={{
            ...mono,
            fontSize: compact ? 11 : 9,
            padding: compact ? "9px 12px" : "4px 8px",
            background: "none",
            border: "1px solid rgba(255,255,255,0.1)",
            color: "rgba(255,255,255,0.3)",
            borderRadius: 8,
            cursor: "pointer",
          }}
        >
          Cancel
        </button>
      </div>
    </div>
  );
}
